import { supabase } from '../supabase';

// Descripción interna de un usuario para el agente (MCP). Solo superadmin
// puede leerla/escribirla (RLS); el usuario descripto no la ve.

export const getUserDescription = async (
  userId: number
): Promise<string | null> => {
  const { data, error } = await supabase
    .from('user_descriptions')
    .select('description')
    .eq('user_id', userId)
    .maybeSingle();
  if (error) throw new Error(error.message);
  return data?.description ?? null;
};

export const upsertUserDescription = async (
  userId: number,
  description: string,
  updatedBy?: number
): Promise<void> => {
  const { error } = await supabase.from('user_descriptions').upsert({
    user_id: userId,
    description,
    updated_at: new Date().toISOString(),
    updated_by: updatedBy ?? null,
  });
  if (error) throw new Error(error.message);
};

export const deleteUserDescription = async (userId: number): Promise<void> => {
  const { error } = await supabase
    .from('user_descriptions')
    .delete()
    .eq('user_id', userId);
  if (error) throw new Error(error.message);
};
